<template>
    <b-modal scrollable b-modal title="Riunione" ref="mdlRsaPazienteRiunioneEquipe" id="mdlRsaPazienteRiunioneEquipe" size="lg" @show="showNuovaRiunione" @ok="onSalvaRiunione" centered no-close-on-backdrop no-close-on-esc hide-header-close style="height: 100%">
        <b-row v-show="!isStepNuovaPersonaRiferimetno">
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-switch-select-element">
                <label class="sa-label-data">Data e Ora</label>
                <date-picker format="DD/MM/YYYY HH:mm" value-type="timestamp" v-model="jsonData.dataOra" type="datetime"></date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <div style="flex: 1; height: 100%; background-color: transparent; overflow: hidden; display: flex; flex-direction: column">
                    <label class="sa-label-data">Verbale:</label>
                    <vue-editor class="sa-qeditor" :editor-toolbar="customToolbar" v-model="jsonData.verbale" />
                </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 10px">
                <b-card class="sa-card sa-card-border" header="Membri equipe" header-tag="header" footer-tag="footer" title="">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaDettaglio" :fields="fieldsEquipe" :current-page="1" :per-page="50" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(profilo)="item">
                            <b-form-select v-if="item.index === jsonData.listaDettaglio.length - 1" v-model="item.item.tipo" :options="equipeTipoOptions" :value="null" value-field="value" text-field="text" @change="onChangeTipo($event)"></b-form-select>
                            <span v-else> {{ item.item.tipo }} </span>
                        </template>
                        <template #cell(nominativo)="item">
                            <b-form-select v-if="item.index === jsonData.listaDettaglio.length - 1" :options="equipeOptions" v-model="nominativo" :value="''" value-field="value" text-field="text" @change="onChangeNominativo($event)"></b-form-select>
                            <span v-else> {{ item.item.nome + " " + item.item.cognome }} </span>
                        </template>
                        <template #cell(actions)="row">
                            <b-button v-if="row.index === jsonData.listaDettaglio.length - 1" size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onAddEquipe(jsonData.listaDettaglio, row.item)">
                                <b-icon icon="plus"></b-icon>
                            </b-button>
                            <b-button v-else size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" @click="onDeleteEquipe(jsonData.listaDettaglio, row)">
                                <b-icon icon="trash"></b-icon>
                            </b-button>
                        </template>
                    </b-table>
                </b-card>
            </b-col>
            <b-col v-if="true" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <span class="sa-flexbox-body-title">Caregiver</span>
                <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" :hidden="false" @click="onNuovaPersonaRiferimento" class="mb-2">
                    <i class="fas fa-plus"></i>
                    Aggiungi
                </b-button>
            </b-col>
        </b-row>
        <b-row v-show="isStepNuovaPersonaRiferimetno">
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <rsa-persona-riferimento-component v-show="!isModalRiunione" ref="cmpRsaPersonaRiferimento" :isOnlyModal="true" :jsonData="jsonDataAccettazione" @afterSaveRequest="onAfterSaveRequestPersonaRiferimento" @closeModal="onCloseModal"></rsa-persona-riferimento-component>
            </b-col>
        </b-row>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import RsaPersonaRiferimentoComponent from "../../components/RsaPersonaRiferimentoComponent.vue";
/* import RsaEquipeComponent from "../../rsagestioneospiti/components/RsaEquipeComponent.vue"; */

export default {
    props: {},
    mixins: [UtilityMixin],
    components: { DatePicker /* RsaEquipeComponent */, RsaPersonaRiferimentoComponent },
    data() {
        return {
            listKey: 0,
            pathResource: "/rsapazienteriunioneequipe",
            pathResourceUsers: "/users",
            pathResourceGruppo: "/gruppi",
            pathResourceEquipe: "/rsaequipe",
            pathResourcePersonaRiferimento: "/rsapersoneriferimento",
            nominativo: "",
            id: null,
            isModalRiunione: true,
            isStepNuovaPersonaRiferimetno: false,
            jsonData: {
                idAccettazione: "",
                dataOra: new Date().getTime(),
                listaDettaglio: [{ nome: "", tipo: "", cognome: "" }],
            },
            jsonDataAccettazione: {},
            filtro: {},
            ossOptions: [],
            animatoreOptions: [],
            psicologoOptions: [],
            equipeOptions: [{ text: "-Seleziona membro equipe-", value: "" }],
            equipeTipoOptions: [],
            fieldsEquipe: [
                { label: "Profilo", key: "profilo", thStyle: "width: 7rem" },
                { label: "Nominativo", key: "nominativo", thStyle: "width: 7rem" },
                { class: "sa-table-column-action-double", label: "", key: "actions" },
            ],
            customToolbar: [
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ],
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        me.loadGruppi();
    },
    watch: {},
    methods: {
        init(jsonDataAccettazione, id) {
            let me = this;
            me.jsonDataAccettazione = jsonDataAccettazione;
            me.idAccettazione = jsonDataAccettazione.id;
            me.id = id;
            me.$refs.mdlRsaPazienteRiunioneEquipe.show();
        },
        showNuovaRiunione() {
            let me = this;
            if (me.id) {
                me.loadData();
            } else {
                me.jsonData = {
                    idAccettazione: me.idAccettazione,
                    dataOra: new Date().getTime(),
                    listaDettaglio: [{ nome: "", tipo: "", cognome: "" }],
                };
                me.loadEquipe();
                me.loadPersonaDiRiferimentoCareGiver();
            }
            /*   setTimeout(() => {
                me.$refs.cmpRsaEquipeList.init(me.idAccettazione);
            }, 1000); */
        },
        loadGruppi() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceGruppo, {}, me.resultResponseGruppi, me.resultErrorGruppi);
        },
        resultResponseGruppi(response) {
            let me = this;
            response.data.data.forEach((element) => {
                if (element.nome !== "ADMINISTRATOR") {
                    me.equipeTipoOptions.push({ text: element.nome, value: element.nome });
                }
            });
            me.equipeTipoOptions.unshift({ text: "- Seleziona Profilo -", value: "" });
        },
        resultErrorGruppi(error) {
            console.log(error);
        },
        loadData() {},

        close() {
            let me = this;
            me.jsonData = {};
            me.$refs.mdlRsaPazienteRiunioneEquipe.hide();
        },
        onChangeTipo(value) {
            let me = this;
            me.equipeOptions = [];
            me.loadUsers(value);
        },
        loadUsers(profilo) {
            let me = this;
            // me.listaDettaglio = [];
            me.filtro = {};
            // if (profilo) {
            me.filtro.profilo = profilo;
            // }
            UtilityMixin.methods.loadDataResources(me.pathResourceUsers, me.filtro, me.loadUsersSuccess, me.loadUserError);
        },
        loadUsersSuccess(response) {
            let me = this;
            response.data.data.list.forEach((element) => {
                me.equipeOptions.push({ text: element.firstname + " " + element.lastname, value: element.firstname + " " + element.lastname });
            });
            me.equipeOptions.unshift({ text: "-Seleziona membro equipe-", value: "" });
        },
        loadUserError(response) {
            console.log(response);
        },

        onClickUndo() {
            let me = this;
            me.$refs.mdlRsaPazienteRiunioneEquipe.hide();
        },
        onSalvaRiunione(bvModalEvent) {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.resultResponse, me.resultError);
            bvModalEvent.preventDefault();
        },
        resultResponse() {
            let me = this;
            me.$refs.mdlRsaPazienteRiunioneEquipe.hide();
            me.$emit("afterSave");
        },
        resultError(error) {
            let me = this;
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "";
            me.$bvToast.toast("Errore:" + messaggio, {
                title: "Salvataggio non riuscito",
                variant: "danger",
                solid: true,
                autoHideDelay: 2000,
            });
        },
        onChangeNominativo(value) {
            let me = this;
            let nomeCompleto = value.split(" ");
            me.jsonData.listaDettaglio.at(-1).nome = nomeCompleto[0];
            me.jsonData.listaDettaglio.at(-1).cognome = nomeCompleto[1];
        },
        onAddEquipe(array, value) {
            let me = this;
            if (value.tipo !== "" && value.nome !== "" && value.cognome !== "") {
                array.push({
                    tipo: "",
                    nome: "",
                    cognome: "",
                });
                me.nominativo = "";
                me.equipeOptions = [];
                me.equipeOptions.unshift({ text: "-Seleziona membro equipe-", value: "" });
            } else {
                this.$bvModal
                    .msgBoxOk("Campi OBBLIGATORI!", {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    })
                    .then((value) => {
                        console.log(value);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        onDeleteEquipe(array, row) {
            if (row.index != array.length) {
                this.$bvModal
                    .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                        title: "Titolo",
                        buttonSize: "sm",
                        okVariant: "secondary",
                        cancelVariant: "danger",
                        okTitle: "SI",
                        cancelTitle: "NO",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            array.splice(row.index, 1);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        loadEquipe() {
            let me = this;
            me.loadDataResources(me.pathResourceEquipe + "/accettazione/" + me.idAccettazione, {}, me.resultResponseEquipe, me.resultErrorEquipe);
        },
        resultResponseEquipe(response) {
            let me = this;
            //if (response.data.data.recordsNumber > 0) {
            let listaEquipe = response.data.data.listaEquipeDettaglio;
            listaEquipe.forEach((element) => {
                me.jsonData.listaDettaglio.unshift({ nome: element.nome, cognome: element.cognome, tipo: element.tipo });
            });
        },
        resultErrorEquipe(/* error */) {
            /* console.log(error); */
            // let me = this;
            /*    me.jsonData.listaDettaglio.unshift({
                tipo: "",
                nome: "",
                cognome: "",
            }); */
            this.$bvToast.toast("Nessuna Equipe assegnata al paziente", {
                title: "Inserire Equipe",
                variant: "warning",
                solid: true,
                autoHideDelay: 2000,
            });
        },
        loadPersonaDiRiferimentoCareGiver() {
            let me = this;
            me.loadDataResources(me.pathResourcePersonaRiferimento, { idAccettazione: me.idAccettazione, caregiver: "SI" }, me.resultResponsePersonaRiferimento, me.resultErrorPersonaRiferimento);
        },
        resultResponsePersonaRiferimento(response) {
            let me = this;
            if (response.data.data.list.length > 0) {
                let careGivers = response.data.data.list;
                careGivers.forEach((element) => {
                    me.jsonData.listaDettaglio.unshift({ nome: element.nome, cognome: element.cognome, tipo: "CARE GIVER" });
                });
                me.isModalRiunione = true;
            } else {
                me.$bvToast.toast("Caregiver non trovato", {
                    title: "Indicare il Caregiver",
                    variant: "warning",
                    solid: true,
                    autoHideDelay: 2000,
                });
                me.isModalRiunione = false;
            }
        },
        resultErrorPersonaRiferimento(error) {
            let me = this;
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "";
            me.$bvToast.toast("Caregiver non trovato" + messaggio, {
                title: "Indicare il Caregiver",
                variant: "warning",
                solid: true,
                autoHideDelay: 2000,
            });
            me.isModalRiunione = false;
        },
        onNuovaPersonaRiferimento() {
            let me = this;
            me.isStepNuovaPersonaRiferimetno = true;
            me.$refs.cmpRsaPersonaRiferimento.show(me.idAccettazione);
        },
        onAfterSaveRequestPersonaRiferimento(careGiver) {
            let me = this;
            if (careGiver) {
                me.isModalRiunione = true;
                me.isStepNuovaPersonaRiferimetno = false;
                me.jsonData.listaDettaglio.unshift({ nome: careGiver.nome, cognome: careGiver.cognome, tipo: "CARE GIVER" });
            } else {
                me.onNuovaPersonaRiferimento();
            }
        },
        onCloseModal() {
            let me = this;
            let caregiver = me.jsonData.listaDettaglio.filter((element) => element.tipo === "CARE GIVER");
            if (caregiver.length > 0) {
                me.$bvToast.toast("Operazione avvenuta con successo", {
                    title: "Caregiver aggiunto",
                    variant: "success",
                    solid: true,
                    autoHideDelay: 2000,
                });
                me.isModalRiunione = false;
                me.isStepNuovaPersonaRiferimetno = false;
            } else {
                me.$bvToast.toast("Caregiver non aggiunto", {
                    title: "Indicare il Caregiver",
                    variant: "warning",
                    solid: true,
                    autoHideDelay: 2000,
                });
                me.isStepNuovaPersonaRiferimetno = false;
                me.isModalRiunione = false;
            }
        },
    },
};
</script>
